import { render } from "./HorseExams.vue?vue&type=template&id=802b6530"
import script from "./HorseExams.vue?vue&type=script&lang=js"
export * from "./HorseExams.vue?vue&type=script&lang=js"

import "./HorseExams.vue?vue&type=style&index=0&id=802b6530&lang=css"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__